import { render, staticRenderFns } from "./AdministrationPage.vue?vue&type=template&id=216a339c"
import script from "./AdministrationPage.vue?vue&type=script&lang=js"
export * from "./AdministrationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports